import { CommonBaseModel } from "app/shared/model";

export class UserConfig extends CommonBaseModel
{
    organisationId?: string;
    defaultTheme?: string;

    init(_data?: any): this {
        super.init(_data);
        return this;
    }
}